export interface IFrameSettings {
  loginToken: string;     // the user's UltiPro "loginToken" for interim authorization purposes.
  siteId: string;         // the GUID of the SiteID from TMS
  tenantId: string;       // the GUID of the TenantID from TMS
  ultiproUrl: string;     // The URL of the origin party's UltiPro
  ultiproCountry: string; // the country setting of the user's UltiPro session
  alias: string;          // the alias from TMS -- of the format 'bwnr2wid-CALEN'. will match the realm in Identity
  locale: string;
  userId: string;         // the user's UserIntegrationKey
  arNumber: string;       // the AR Number / Account ID of the company from UltiPro.
  email: string;                  // the user's email addressfrom UltiPro
}

export class IFrameUtils {
   static getSettingsFromFragment(fragment: string): IFrameSettings {
    if (!fragment || fragment.length === 0) {
      return null;
    }

    try {
      const data = JSON.parse(atob(fragment));

      return {
        loginToken: data.loginToken,
        siteId: data.siteKey,
        tenantId: data.tenantId,
        ultiproUrl: data.ultiproUrl,
        ultiproCountry: data.country,
        alias: data.alias,
        locale: data.locale,
        userId: data.userId,
        arNumber: data.arNumber,
        email: data.email
      };
    } catch {
      return null;
    }
  }
}
